(function($, exports) {

	exports.init = function() {
		WebFontConfig = {
			custom: {
				families: ['sofia', 'newzald']
			},
			active: function() {
			    sessionStorage.fonts = true;
			}
		};

		var d = document;
		var wf = d.createElement('script'), s = d.scripts[0];
		wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
		wf.async = true;
		s.parentNode.insertBefore(wf, s);
	};
	
})(jQuery, this.WEBFONTS = {});